<template>
  <div class="wg-row com-anm22-app-inner-wrapper">
    <wg-modal :simple="true" :width="'300px'" v-if="showStatusModal" @closeModal="showStatusModal = false">
      <div slot="body" class="wg-row">
        <div class="com-anm22-app-text-l">
          {{ $anm22.strLang(lang, 'Select order status', 'Seleziona stato dell\'ordine') }}
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div
            v-for="(status,index) in $anm22.tableClasses.foodOrderStatus().getAll()"
            :key="'s-'+index"
            class="wg-row com-anm22-app-text-l selectable"
            :style="{color: getStatusLabelStyle(status.typeClass)}"
            @click="changeStatus(status)"
        >{{ status[lang] }}</div>
      </div>
    </wg-modal>
    <wg-modal :simple="true" :width="'300px'" v-if="showTimeModal" @closeModal="showTimeModal = false">
      <div slot="body" class="wg-row" style="justify-content:center;">
        <div class="com-anm22-app-text-l">
          {{ $anm22.strLang(lang, "Select estimated time", "Seleziona tempo stimato") }}
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div
            v-for="(n,i) in 25"
            :key="'n-'+i"
            class="wg-row com-anm22-app-text-l selectable"
            style="justify-content:center;"
            @click="changeEstimatedTime(n*5)"
        >{{ n * 5 }}</div>
      </div>
    </wg-modal>
    <div class="wg-row" style="flex-wrap:nowrap;align-items:center;justify-content:space-between;">
      <!-- TITLE -->
      <div class="display-flex">
        <img 
            :src="$anm22.getObjIcon(work, 'workDefault')"
            class="com-anm22-app-img-fixed-height-m"
            style="margin-right:12px;">
        <div class="com-anm22-app-text-xxl">
          {{ work.name + ' - ' + $anm22.strLang(lang, 'Orders', 'Ordini') }}
        </div>
      </div>
      <!-- STOP ORDERS BUTTON -->
      <div class="display-flex">
        <button class="small" style="border: 1px solid #bbb;background-color:#fff;color:#263238;" @click="toggleOrders">
          <img style="height:25px;width:24px;" :src="$anm22.icons.getWorldIcon(license.interrupted ? 'play' : 'stop')">
          <div v-if="windowWidth > 767">{{ 
            !license.interrupted
                ? $anm22.strLang(lang, 'Stop taking orders', 'Ferma ricezione ordini')
                : $anm22.strLang(lang, 'Start taking orders', 'Riprendi ricezione ordini')  
          }}</div>
        </button>
        <div class="horizontal-height-div" style="width:5px;"></div>
        <button class="small green" @click="openOrder({})">
          <img :src="$anm22.icons.getWorldIcon('add')">
          <div v-if="windowWidth > 767">{{ $anm22.strLang(lang, 'New order', 'Nuovo ordine') }}</div>
        </button>
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <!-- Order filters -->
    <div class="wg-row" style="align-items:center;flex-wrap:nowrap;">
      <!-- date filter -->
      <div class="display-flex" style="position:relative;">
        <div
          class="wg-row dropdown-button"
          style="width:180px;"
          @click="showDateFilter = !showDateFilter"
        >
          <div class="wg-row dropdown-button-row">
            <div
              class="com-anm22-app-text-l"
            >{{ dateFilters.find(df => df.id === dateFilter)[lang] }}</div>
            <img
              class="com-anm22-app-img-fixed-height-s"
              style="margin-left:4px;"
              :src="$anm22.icons.getWorldIcon('arrowDown')"
            >
          </div>
        </div>
        <div v-show="showDateFilter" class="wg-row dropdown-list">
          <div
            v-for="(df,index) in dateFilters.filter(df => df.id !== dateFilter)"
            :key="'df-'+index"
            class="wg-row dropdown-list-item"
            @click="selectDateFilter(df)"
          >
            <div
              class="wg-row com-anm22-app-text-m dropdown-list-item-text"
            >{{ df[lang] }}</div>
          </div>
        </div>
      </div>
      <input
        v-if="dateFilter === 'select'"
        type="date"
        style="width:auto;margin-left:10px;"
        v-model.lazy="dateSelector"
        @change="changeDateSelector"
      >
      <!-- Status filter -->
      <div class="display-flex" style="position:relative;margin-left:10px;">
        <div
          class="wg-row dropdown-button"
          style="width:180px;"
          @click="showStatusFilter = !showStatusFilter"
        >
          <div class="wg-row dropdown-button-row">
            <div
              class="com-anm22-app-text-l"
            >{{ statusFilters.find(s => s.id === mode)[lang] }}</div>
            <img
              class="com-anm22-app-img-fixed-height-s"
              style="margin-left:4px;"
              :src="$anm22.icons.getWorldIcon('arrowDown')"
            >
          </div>
        </div>
        <div v-show="showStatusFilter" class="wg-row dropdown-list">
          <div
            v-for="(s,index) in statusFilters.filter(s => s.id !== mode)"
            :key="'status-'+index"
            class="wg-row dropdown-list-item"
            @click="selectMode(s)"
          >
            <div
              class="wg-row com-anm22-app-text-m dropdown-list-item-text"
            >{{ s[lang] }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="vertical-height-div" style="height:20px;"></div>
    <div class="wg-row" :style="{ height: listHeight + 'px'}">
      <w-g-list
          :loading="loading"
          :pagination="true"
          :fieldInit="'orderDate'"
          :keyField="'id'"
          :clickFn="order => openOrder(order)"
          :headerItems="headerItems"
          :itemsToDisplay="tableItems"
      >
        <template v-slot:default="{ element, data }">
          <div class="wg-row order-row" style="flex-wrap:nowrap;align-items:center;">
            <div class="wg-col wg-xs-2 wg-sm-1" style="cursors:pointer;">
              <div class="com-anm22-app-text-l">
                {{ element.number ? element.number : ( Number.isInteger(element.id) ? element.id : element.id.slice(-4) ) }}
              </div>
            </div>
            <div class="wg-col wg-xs-5 wg-sm-4" style="cursors:pointer;">
              <div 
                  class="wg-row" 
                  :style="{flexWrap: 'nowrap', alignItems: 'center', overflow:'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'}"
              >
                <div style="min-width:20px;width:20px;height:320x;margin-right:2px;">
                  <world-object-icon
                      :type="'user'" 
                      :obj="data.user"
                      :isImg="true">
                  </world-object-icon>
                </div>
                <div class="com-anm22-app-text-l">
                  {{ getCustomerName(data.user) }}
                </div>
                <img
                    v-if="element.customer && element.customer === element.createdBy"
                    class="com-anm22-app-img-s" 
                    style="margin:0 3px;"
                    :src="$anm22.icons.getWorldIcon('smartphone')">
                <img
                  class="com-anm22-app-img-s" 
                  style="margin:0 3px;"
                  :src="$anm22.icons.getWorldIcon($anm22.tableClasses.worldDeliveryType().getById(element.deliveryType)['typeClassLiteral'])">
                <template v-if="element.deliveryType === 5">
                  <div class="com-anm22-app-text-l" style="margin:0 3px;">{{ data.table.name }}</div>
                </template> 
                <template v-if="element.deliveryType === 1 || element.deliveryType === 2">
                  <div class="com-anm22-app-text-l" style="margin:0 3px;">{{ data.beach.name + ' - ' + element.beachUmbrella }}</div>
                </template>  
                <template v-if="element.deliveryType === 9">
                  <div class="com-anm22-app-text-l" style="margin:0 3px;">{{ element.pickUpPoint[lang] }}</div>
                </template>
              </div>
            </div>
            <div class="wg-col wg-xs-none wg-sm-2">
              <div class="com-anm22-app-text-l">
                {{ $moment.tz(element.orderDate, 'X', timezone).format('DD-MM-YYYY HH:mm') }}
              </div>
            </div>
            <div 
                class="wg-col wg-xs-2" 
                style="font-weight:bold;"
                @click.stop="openStatusModal(element)">
              <div 
                  class="com-anm22-app-text-l"
                  :style="{overflow:'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', color: getStatusLabelStyle(element.status)}"
              >
                {{ $anm22.tableClasses.foodOrderStatus().getById(element.status)[lang] }}
              </div>
            </div>
            <div class="wg-col wg-xs-none wg-sm-2"
                @click.stop="openTimeModal(element)">
              <div class="com-anm22-app-text-l" >
                {{ element.estimatedTime ? element.estimatedTime + ' min' : '' }}
              </div>
            </div>
            <div class="wg-col wg-xs-2 wg-sm-1" style="margin-left:auto;">
              <div class="wg-row" style="justify-content:flex-end;">
                <div class="com-anm22-app-text-l">
                  {{ getAmount(element).toFixed(2) + ' &euro;' }}
                </div>
              </div>
            </div>
          </div>
        </template>
      </w-g-list>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import WGList from '../../../../../world/spa/components/WGList.vue';

export default {
  data() {
    return {
      loading: true,
      firstLoad: true,
      showStatusFilter: false,
      showDateFilter: false,
      mode: 'waiting', // waiting / all
      dateFilter: '',
      dateSelector: '',
      showStatusModal: false,
      showTimeModal: false,
      editingOrder: null,
      lastUpdate: null,
      newOrders: []
    }
  },
  components: {
    WGList
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      licenseSelected: state => state.licenseSelected,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight,
      isOffline: state => state.offline.isOffline
    }),
    listHeight() {
      return this.windowHeight - 190;
    },
    statusFilters() {
      return [
        {
          id: 'waiting',
          en: 'Waiting',
          it: 'In attesa'
        },
        {
          id: 'all',
          en: 'All',
          it: 'Tutti'
        }
      ]
    }, 
    dateFilters() {
      return [
        {
          id: '',
          en: 'Last 24 hours',
          it: 'Ultime 24 ore'
        },
        {
          id: 'today',
          en: 'Today',
          it: 'Oggi'
        },
        {
          id: 'yesterday',
          en: 'Yesterday',
          it: 'Ieri'
        },
        {
          id: 'week',
          en: 'Last 7 days',
          it: 'Ultimi 7 giorni'
        },
        {
          id: 'month',
          en: 'Last 30 days',
          it: 'Ultimi 30 giorni'
        },
        {
          id: 'select',
          en: 'From',
          it: 'Da'
        }
      ]
    },
    license() {
      return this.$store.getters['foodLicenses/getByHash'](this.licenseSelected);
    },
    employment() {
      return this.$store.getters['foodEmployments/get'](this.license.id + '-' + this.user.idWorldUser )
    },
    permission() {
      return this.employment.permission;
    },
    acs() {
      return this.$store.getters['foodAcs/get'](this.license.id + "-" + this.permission);
    },
    work() {
      return this.$store.getters['works/get'](this.license.work);
    },
    timezone() {
      return this.work.timezone;
    },
    orders() {
      const today = this.$moment.tz(this.timezone).startOf('day');
      return this.$store.getters['foodOrders/getByLicense'](this.license.id)
        .filter(o => {
          if(this.mode === 'waiting' && (o.status === 2 || o.status === 6)) {
            return false;
          }
          switch(this.dateFilter) {
            case 'today':
              if(o.orderDate < today.unix()){
                return false;
              }
              break;
            case 'yesterday':
              if(o.orderDate < today.clone().subtract(1, 'days').unix() || o.orderDate >= today.unix()){
                return false;
              }
              break;
            case 'week':
              if(o.orderDate < today.clone().subtract(7, 'days').unix()){
                return false;
              }
              break;
            case 'month':
              if(o.orderDate < today.clone().subtract(30, 'days').unix()){
                return false;
              }
              break;
            case 'select':
              if(o.orderDate < this.$moment.tz(this.dateSelector, 'YYYY-MM-DD', this.timezone).startOf('day').unix()){
                return false;
              }
              break;
            //24hours
            default:
              if(o.orderDate < this.$moment.tz(this.timezone).subtract(1, 'days').unix()){
                return false;
              }
          }
          return true;
        });
    },
    headerItems() {
      return [
        {
          field: 'id',
          label: 'ID',
          class: 'wg-xs-2 wg-sm-1',
          disabled: false,
        },
        {
          field: 'customer',
          label: this.$anm22.strLang(this.lang, 'Customer', 'Cliente'),
          class: 'wg-xs-5 wg-sm-4',
          disabled: false,
        },
        {
          field: 'orderDate',
          label: this.$anm22.strLang(this.lang, 'Date', 'Data'),
          class: 'wg-xs-none wg-sm-2',
          disabled: false,
        },
        {
          field: 'status',
          label: this.$anm22.strLang(this.lang, 'Status', 'Stato'),
          class: 'wg-xs-2 wg-sm-2',
          disabled: false,
        },
        {
          field: 'estimatedTime',
          label: this.$anm22.strLang(this.lang, 'Estimated time', 'Tempo stimato'),
          class: 'wg-xs-none wg-sm-2',
          disabled: false,
        },
        {
          field: 'total',
          label: this.$anm22.strLang(this.lang, 'Total', 'Totale'),
          class: 'wg-xs-3 wg-sm-1',
          style: {justifyContent: 'flex-end'},
          disabled: false,
        }
      ]
    },
    tableItems() {
      return this.orders.map(o => {
        let user = null;
        if(o.customer) {
          user = this.$store.getters['users/get'](o.customer) || null;
        } else {
          user = this.$store.getters['users/get'](o.createdBy) || null;
        }
        const table = this.$store.getters['foodTables/get'](o.tableRef) || null;
        const beach = this.$store.getters['works/get'](o.beach) || null;
        return {
          ...o,
          'list-metadata': {
            type: 'item',
            user: user,
            table: table,
            beach: beach
          }
        }
      });
    }
  },
  methods: {
    selectDateFilter(filter) {
      this.dateFilter = filter.id;
      this.showDateFilter = false;
      if(this.dateFilter !== 'select') {
        this.dateSelector = '';
        this.loadOrders();
      }
      this.saveFilters();
    },
    changeDateSelector: _.debounce(function(ev) {
      this.dateSelector = ev.target.value;
      this.loadOrders();
    }, 2000),
    selectMode(mode) {
      this.mode = mode.id;
      this.showStatusFilter = false;
      this.saveFilters();
    },
    saveFilters() {
      this.$anm22.setCookie(
        'fd_ol_filters', 
        JSON.stringify({
          date: this.dateFilter,
          date_s: this.dateSelector,
          mode: this.mode,
        }), 
        600
      );
    },
    resetFilters() {
      this.dateFilter = '';
      this.dateSelector = this.$moment.tz(this.timezone).format('YYYY-MM-DD');
      this.mode = 'waiting';
    },
    openOrder(order) {
      if(order.customer) {
        this.$router.push('/orders/' + order.id).catch(e => console.log(e));
      } else if(this.acs && this.acs.fastCash) {
        this.$router.push('/fastCash/' + order.id).catch(e => console.log(e));
      } else {
        this.$router.push('/takeOrder/' + order.id).catch(e => console.log(e));
      }
    },
    getCustomerName(customer) {
      if(customer) {
        return customer.name.substring(0,1) + ' ' + customer.surname;
      } else {
        return this.$anm22.strLang(this.lang, 'User', 'Utente');
      }
    },
    getStatusLabelStyle(status) {
      switch(status) {
        case 1:
          return '#FF6D00';
        case 2: 
          return '#BF360C';
        case 3:
          return '#FBC02D';
        case 4:
          return '#7CB342';
        case 5:
          return '#4FC3F7';
        case 6:
          return '#0091EA';
      }
    },
    getAmount(order) {
      return order.toPayTotal + Number(order.payedTotal);
    },
    openStatusModal(order) {
      this.editingOrder = {...order};
      this.showStatusModal = true;
    },
    changeStatus(status) {
      this.$http
      .post('orders/change-status', {
        orderId: this.editingOrder.id,
        status: status.typeClass
      })
      .then(response => {
        this.$store.dispatch("foodOrders/update",{
          vlf: this.$vlf('foodOrders'), objs: response.data.orders
        });
      })
      .catch(error => {
        this.editingOrder.status = status.typeClass;
        this.$store.dispatch("foodOrders/update",{
          vlf: this.$vlf('foodOrders'), objs: [this.editingOrder]
        });
        // this.$anm22.saveSyncTuple(vue, "FoodOrder", "edit", this.editingOrder);
        this.$store.dispatch('offline/saveSyncTuple', {
          _vue: this,
          _class: "FoodOrder",
          _table: "foodOrders",
          mode: 'edit',
          type: 'obj',
          obj: this.editingOrder
        });
      })
      .finally(() => {
        this.editingOrder = null;
        this.showStatusModal = false;
      })
    },
    openTimeModal(order) {
      this.editingOrder = {...order};
      this.showTimeModal = true;
    },
    changeEstimatedTime(time) {
      this.$http
      .post('orders/change-time', {
        orderId: this.editingOrder.id,
        time: time
      })
      .then(response => {
        this.$store.dispatch("foodOrders/update",{
          vlf: this.$vlf('foodOrders'), objs: response.data.orders
        });
      })
      .catch(error => {
        this.editingOrder.estimatedTime = time;
        this.$store.dispatch("foodOrders/update",{
          vlf: this.$vlf('foodOrders'), objs: [this.editingOrder]
        });
        // this.$anm22.saveSyncTuple(vue, "FoodOrder", "edit", this.editingOrder);
        this.$store.dispatch('offline/saveSyncTuple', {
          _vue: this,
          _class: "FoodOrder",
          _table: "foodOrders",
          mode: 'edit',
          type: 'obj',
          obj: this.editingOrder
        });
      })
      .finally(() => {
        this.editingOrder = null;
        this.showTimeModal = false;
      })
    },
    toggleOrders() {
      this.$http.post('orders/toggle-ordering')
        .then(response => {
          this.$store.dispatch('foodLicenses/update', {
            vlf: this.$vlf('foodLicenses'), objs: response.data.foodLicenses
          });
        });
    },
    async loadOrders() {
      this.loading = true;
      const response = await this.$http.get('orders/load', {
        params: {
          s: this.dateFilter,
          d: this.dateSelector
        }
      });
      const result = await Promise.all([
        this.$store.dispatch("foodOrders/update",{
          vlf: this.$vlf('foodOrders'),
          objs: response.data.orders,
          cleanFilters: this.firstLoad ? [] : null
        }),
        this.$store.dispatch("users/update",{
          vlf: this.$vlf('users'),
          objs: response.data.users
        }),
        this.$store.dispatch("works/update",{
          vlf: this.$vlf('works'),
          objs: response.data.works
        }),
        this.$store.dispatch("foodTables/update",{
          vlf: this.$vlf('foodTables'),
          objs: response.data.tables
        })
      ]);
      this.firstLoad = false;
      this.loading = false;
    },
    loadData() {
      return Promise.all(
        [
          this.$store.dispatch('foodLicenses/load', this.$vlf('foodLicenses')),
          this.$store.dispatch('foodTables/load', this.$vlf('foodTables')),
          this.$store.dispatch('works/load', this.$vlf('works')),
          this.$store.dispatch('foodOrders/load', this.$vlf('foodOrders'))
        ]
      );
    },
    async updateData() {
      if (!this.isOffline) {
        try {
          const response = await this.$http.get("orders/refresh?t="+this.lastUpdate);
          await Promise.all([
            this.$store.dispatch("foodOrders/update", {
              vlf: this.$vlf('foodOrders'), objs: response.data.orders
            }),
            this.$store.dispatch("users/update", {
              vlf: this.$vlf('users'),
              objs: response.data.users
            }),
            this.$store.dispatch("works/update", {
              vlf: this.$vlf('works'),
              objs: response.data.works
            }),
            this.$store.dispatch("foodTables/update", {
              vlf: this.$vlf('foodTables'),
              objs: response.data.tables
            })
          ]);
          this.lastUpdate = this.$moment().unix();
        } catch (e) {}
      }
    }
  },
  created() {
    if(!this.employment) {
      this.$router.push("history").catch((e) => console.log(e));
      return;
    }
    document.title = this.$anm22.strLang(this.lang, "Orders", "Ordini");
    this.$store.dispatch(
      "headbar/setHeadbarTitle",
      this.$anm22.strLang(this.lang, "Orders", "Ordini")
    );
    // this.dateSelector = this.$moment.tz(this.timezone).format('YYYY-MM-DD');
    // Check selection cookie
    if(this.$anm22.getCookie('fd_ol_filters') !== '') {
      const filters = JSON.parse(this.$anm22.getCookie('fd_ol_filters'));
      this.dateFilter = filters.date;
      this.dateSelector = filters.date_s;
      this.mode = filters.mode;
    }
    this.loadData();
    //Get orders
    this.$http
      .get("orders")
      .then(response => {
        Promise.all([
          this.$store.dispatch("foodLicenses/update",{
            vlf: this.$vlf('foodLicenses'), objs: response.data.foodLicenses
          }),
          this.$store.dispatch("foodEmployments/update",{
            vlf: this.$vlf('foodEmployments'), objs: response.data.foodEmployments
          }),
          this.$store.dispatch("foodAcs/update",{
            vlf: this.$vlf('foodAcs'), objs: response.data.foodAcs
          }),
          this.$store.dispatch("foodTables/update",{
            vlf: this.$vlf('foodTables'), objs: response.data.tables
          }),
          this.$store.dispatch("works/update",{
            vlf: this.$vlf('works'), objs: response.data.works
          })
        ])
        .then(() => {
          this.lastUpdate = this.$moment().unix();
          this.loading = false;
          this.$Progress.finish();
          this.loadOrders();
        });
      })
      .catch(error => {
        this.loading = false;
        this.$Progress.finish();
      });
  },
  mounted() {
    this.$nextTick(() => {
      this.updateInterval = setInterval(() => {
        this.updateData();
      }, 30000);
    });
  },
  destroyed() {
    clearInterval(this.updateInterval);
  }
}
</script>

<style lang="scss" scoped>
.dropdown-button {
  height: 36px;
  border-radius: 4px;
  border: 1px solid #bbb;
  padding: 8px 10px;
  cursor: pointer;
  background-color: #fff;
  &:hover {
    background-color: #eee;
  }
}
.dropdown-button-row {
  font-weight: 600;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
}
.dropdown-list {
  flex-direction: column;
  align-items: center;
  position: absolute;
  z-index: 100;
  top: 36px;
  border-radius: 4px;
  border: 1px solid #999;
  background-color: #fff;
}
.dropdown-list-item {
  height: 36px;
  align-items: center;
  padding: 10px;
  cursor: pointer;
  &:hover {
    background-color: #eee;
  }
}
.dropdown-list-item-text {
  justify-content: center;
  border-radius: 4px;
}
.order-row {
  height: 36px;
  padding: 10px 0;
  &:hover {
    background-color: #fff;
  }
}
.selectable {
  padding: 5px;
  margin-bottom: 5px;
  cursor: pointer;
  border-radius: 5px;
  &:hover {
    background-color: #eee;
  }
}
</style>
